import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { getApiSetting, multiFocus, postApiSetting } from "../assets/functions";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { TableStatusRow, StatusBadge } from "../components/UI";

export default function PMerchantManagement ({setAuth}) {

    const { register, handleSubmit, formState:{ errors } } = useForm();
     const navigate = useNavigate();

    const [pMerchantData, setPMerchantData] = useState([]);
    const [meDetails, setMeDetails] = useState({});
    const [editForm, setEditForm] = useState(false);

    // const pmtModeRef = useRef(null);
    // const meTypeRef = useRef(null);

    useEffect(()=>{
        (async()=>{
            try {
                // let res = await fetch('/admin/api/Admin/Management/fetchPendingMerchants', getApiSetting());
                let res = await fetch('/Admin/api/Admin/Management/fetchPendingMerchants', getApiSetting());
                let result = (res.status === 200) ? await res.json(): "";
                if(res.status === 200){
                    setPMerchantData(result.data.responseData)
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) {
                console.log(error)
            }
        })()
    },[editForm])

    // useEffect(()=>{
    //     let pmchecks = pmtModeRef.current.querySelectorAll(`input[type="checkbox"]`);
    //     if(meDetails.paymentMode && meDetails.paymentMode!=="false"){
    //         let modeList = meDetails.paymentMode.split(',');
    //         modeList.forEach((item) => {
    //             pmtModeRef.current.querySelector(`input[value="${item}"]`).checked=true;
    //         })
    //     }else{
    //         pmchecks.forEach(item => item.checked=false )
    //     }
    // },[editForm])

    const editMeDetail = (data) => { 
        // console.log(data)
        setEditForm(true)
        multiFocus('._editP')
        setMeDetails(data)
    }

    const submitMeDetailForm = async (data) => {
        // let pmChecks = pmtModeRef.current.querySelectorAll(`input[type="checkbox"]`);
        // let typeChecks = meTypeRef.current.querySelectorAll(`input[type="radio"]`);
        // let pmChecked = Array.from(pmChecks).some(x => x.checked);
        // let meTypeChecked = Array.from(typeChecks).some(x => x.checked);

        // if(!pmChecked){
        //     alert('Please select atleast one payment mode.')
        //     return false;
        // }
        // if(!meTypeChecked){
        //     alert('Merchant type is required')
        //     return false;
        // }

        // let paymentMode = data.paymentMode.toString();
        // let settings = postApiSetting({...data, paymentMode})
        let settings = postApiSetting(data)
        try {
            // let res = await fetch('/admin/api/Admin/Management/aprPendingMerchants', settings);
            let res = await fetch('/Admin/api/Admin/Management/aprPendingMerchants', settings);
            let result = (res.status === 200) ? await res.json(): "";
            // console.log(res)
            // console.log(result)
            if(res.status !== 200){
                 if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            }else{
                if(result.data.responseCode === '00'){
                    alert('SUCCESS : '+result.data.responseMsg)
                    setEditForm(false)
                }else{
                    alert('FAILED : '+result.data.responseMsg)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    // console.log(meDetails)

    return (<>
        {/* <SidebarNavigation /> */}
        <div className="dashboard-page w-100">
            <ToastContainer />
            <Navbar title="MERCHANT MANAGEMENT" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                <h6 className="mb-3">Merchant Management — Pending</h6>
                <div className="table-responsive" style={{display:editForm?'none':'block'}}>          
                <table className="table table-bordered com-table">
                    <thead>
                    <tr>
                        <th>User Id</th>
                        <th>Mid</th>
                        <th>Description</th>
                        <th>Owner Name</th>
                        <th>Mobile No</th>
                        <th>Email Id</th>
                        <th>Alternate Mobile No</th>
                        <th>Business Type</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Country</th>
                        <th>Legal Name</th>
                        <th>Locality/Address</th>
                        <th>Company/StoreName</th>
                        <th>Nature Of Business</th>
                        <th>Pan No</th>
                        <th>Adhar No</th>
                        <th>Pin Code</th>
                        <th>Gst No</th>
                        <th>Store Type</th>
                        <th>Status</th>
                        <th>Creation Date</th>
                        <th>Modification Date</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {pMerchantData.length === 0 ? <TableStatusRow colSpan={24} status="Not Found" /> :
                    pMerchantData.map((item)=>{
                        return (
                        <tr key={item.id}>
                            <td>{item.userId}</td>
                            <td>{item.mid}</td>
                            <td>{item.description}</td>
                            <td>{item.ownerName}</td>
                            <td>{item.mobileNo}</td>
                            <td>{item.emailId}</td>
                            <td>{item.alternateMobileNo}</td>
                            <td>{item.businessType}</td>
                            <td>{item.City}</td>
                            <td>{item.state}</td>
                            <td>{item.country}</td>
                            <td>{item.legalName}</td>
                            <td>{item.localityOrAddress}</td>
                            <td>{item.companyOrStoreName}</td>
                            <td>{item.natureOfBusiness}</td>
                            <td>{item.panNo}</td>
                            <td>{item.adharNo}</td>
                            <td>{item.pincode}</td>
                            <td>{item.gstNo}</td>
                            <td>{item.storeType}</td>
                            <td><StatusBadge status={item.status} /></td>
                            <td>{item.creationDate}</td>
                            <td>{item.modificationDate}</td>
                            <td>
                                <button className="btn btn-sm _themebg-0 text-white mx-1" onClick={()=>editMeDetail(item)}>Edit</button>
                            </td>
                        </tr>
                        )
                    })}
                    </tbody>
                </table>
                </div>
                
                <form className='border p-4' onSubmit={handleSubmit(submitMeDetailForm)} style={{display:editForm?'block':'none'}}>

                    <div className='row mb-3'>
                        <div className='col-md-12'>
                            <h6 className="section-banner mb-3">Merchant Onboarding — Basic Details</h6>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">User Id <strong className='text-danger'>*</strong></label>
                                <input id="userid" type="text" className="form-control shadow-none _editP" defaultValue={meDetails.userId}
                                {...register('userId', { required : { value:true, message:"This field is required" } })} />
                                {errors.userId && <strong className="text-danger"><small>{errors.userId.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label"> Company / Store Name <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.companyOrStoreName}
                                {...register('companyOrStoreName', { required : { value:true, message:"This field is required" } })} />
                                {errors.companyOrStoreName && <strong className="text-danger"><small>{errors.companyOrStoreName.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">User Name <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.ownerName}
                                {...register('ownerName', { required : { value:true, message:"This field is required" } })} />
                                {errors.ownerName && <strong className="text-danger"><small>{errors.ownerName.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Mobile No. <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.mobileNo}
                                {...register('mobileNo', { required : { value:true, message:"This field is required" } })} />
                                {errors.mobileNo && <strong className="text-danger"><small>{errors.mobileNo.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Alternate Mobile No. <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.alternateMobileNo}
                                {...register('alternateMobileNo', { required : { value:true, message:"This field is required" } })} />
                                {errors.alternateMobileNo && <strong className="text-danger"><small>{errors.alternateMobileNo.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">User Email <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.emailId}
                                {...register('emailId', { required : { value:true, message:"This field is required" } })} />
                                {errors.emailId && <strong className="text-danger"><small>{errors.emailId.message}</small></strong>}
                            </div>
                        </div>
                        {/* <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Nature Of Business <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" value={meDetails.natureOfBusiness}
                                {...register('natureOfBusiness', { required : { value:true, message:"This field is required" } })} />
                                {errors.natureOfBusiness && <strong className="text-danger"><small>{errors.natureOfBusiness.message}</small></strong>}
                            </div>
                        </div> */}
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Nature Of Business <strong className='text-danger'>*</strong></label>
                                <select id="natureofbusiness" className="form-select shadow-none _editP" {...register('natureOfBusiness', 
                                { required : { value:true, message:"This field is required" } })} value={meDetails.natureOfBusiness||''} >
                                    <option value="">--Select--</option>
                                    <option value="retail">Retail</option> 
                                    <option value="insurance">Insurance</option>
                                    <option value="education">Education</option> 
                                </select>
                                {errors.natureOfBusiness && <strong className="text-danger"><small>{errors.natureOfBusiness.message}</small></strong>}
                            </div>
                        </div>
                        {/* <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Business Type <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" value={meDetails.businessType}
                                {...register('businessType', { required : { value:true, message:"This field is required" } })} />
                                {errors.businessType && <strong className="text-danger"><small>{errors.businessType.message}</small></strong>}
                            </div>
                        </div> */}
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Business Type <strong className='text-danger'>*</strong></label>
                                <select className="form-select shadow-none _editP" value={meDetails.businessType||''}
                                {...register('businessType', { required : { value:true, message:"This field is required" } })}>
                                    <option value="">--Select--</option>
                                    <option value="pvt ltd">Pvt Ltd</option>
                                    <option value="llp">LLP</option>
                                    <option value="proprietorship">Proprietorship</option>
                                </select>
                                {errors.businessType && <strong className="text-danger"><small>{errors.businessType.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Address/Locality <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.localityOrAddress}
                                {...register('localityOrAddress', { required : { value:true, message:"This field is required" } })} />
                                {errors.localityOrAddress && <strong className="text-danger"><small>{errors.localityOrAddress.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">City <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.city}
                                {...register('city', { required : { value:true, message:"This field is required" } })} />
                                {errors.city && <strong className="text-danger"><small>{errors.city.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">State <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.state}
                                {...register('state', { required : { value:true, message:"This field is required" } })} />
                                {errors.state && <strong className="text-danger"><small>{errors.state.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Country <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.country}
                                {...register('country', { required : { value:true, message:"This field is required" } })} />
                                {errors.country && <strong className="text-danger"><small>{errors.country.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">PinCode <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.pincode}
                                {...register('pincode', { required : { value:true, message:"This field is required" } })} />
                                {errors.pincode && <strong className="text-danger"><small>{errors.pincode.message}</small></strong>}
                            </div>
                        </div>
                        {/* <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Store Type <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" value={meDetails.storeType}
                                {...register('storeType', { required : { value:true, message:"This field is required" } })} />
                                {errors.storeType && <strong className="text-danger"><small>{errors.storeType.message}</small></strong>}
                            </div>
                        </div> */}
                         <div className='col-md-3'> 
                            <div className="mb-2">
                                <label className="form-label">Store Type <strong className='text-danger'>*</strong></label>
                                <select className="form-select shadow-none _editP" value={meDetails.storeType||''}
                                {...register('storeType', { required : { value:true, message:"This field is required" } })}>
                                    <option value="">--Select--</option>
                                    <option value="physical">Physical</option>
                                    <option value="online">Online</option>
                                </select>
                                {errors.storeType && <strong className="text-danger"><small>{errors.storeType.message}</small></strong>}
                            </div>
                        </div> 
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Aadhar No. <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.adharNo}
                                {...register('adharNo', { required : { value:true, message:"This field is required" } })} />
                                {errors.adharNo && <strong className="text-danger"><small>{errors.adharNo.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Pan No. <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.panNo}
                                {...register('panNo', { required : { value:true, message:"This field is required" } })} />
                                {errors.panNo && <strong className="text-danger"><small>{errors.panNo.message}</small></strong>}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Gst No. <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none _editP" defaultValue={meDetails.gstNo}
                                {...register('gstNo', { required : { value:true, message:"This field is required" } })} />
                                {errors.gstNo && <strong className="text-danger"><small>{errors.gstNo.message}</small></strong>}
                            </div>
                        </div>
                    </div>

                    {/* <div className='row'>
                        <div className='col-md-12'>
                            <h6 className="bg-secondary text-white p-2 mb-3">Merchant Onboarding ( Advance Details )</h6>
                        </div>

                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">IP / URL. <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('ipOrUrl', { required : { value:true, message:"This field is required" } })} />
                                {errors.ipOrUrl && <strong className="text-danger"><small>{errors.ipOrUrl.message}</small></strong>}
                            </div>
                        </div>

                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">MCC <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('mcc', { required : { value:true, message:"This field is required" } })} />
                                {errors.mcc && <strong className="text-danger"><small>{errors.mcc.message}</small></strong>}
                            </div>
                        </div>

                        <div className='col-md-3'>
                            <div className="mb-2">
                                <label className="form-label">Currency <strong className='text-danger'>*</strong></label>
                                <select className="form-select shadow-none" {...register('currency', { required : { value:true, message:"This field is required" } })}>
                                    <option value="">--Select--</option>
                                    <option value="INR">INR</option>
                                    <option value="EURO">EURO</option>
                                </select>
                                {errors.currency && <strong className="text-danger"><small>{errors.currency.message}</small></strong>}
                            </div>
                        </div>

                        <div className='col-md-12 mb-2'>
                            <label className="form-label">Please Select Payment Mode <strong className='text-danger'>*</strong></label>
                            <ul className="list-group list-group-horizontal" ref={pmtModeRef}>
                                <li className="list-group-item">
                                    <div className="form-check">
                                    <input className="form-check-input me-2 shadow-none" type="checkbox" value="UPII" id="pmcheck_1" {...register('paymentMode')} />
                                    <label className="form-check-label" htmlFor="pmcheck_1">UPII</label>
                                    </div>
                                </li>
                                <li className="list-group-item">
                                    <div className="form-check">
                                    <input className="form-check-input me-2 shadow-none" type="checkbox" value="UPIC" id="pmcheck_2" {...register('paymentMode')} />
                                    <label className="form-check-label" htmlFor="pmcheck_2">UPIC</label>
                                    </div>
                                </li>
                                <li className="list-group-item">
                                    <div className="form-check">
                                    <input className="form-check-input me-2 shadow-none" type="checkbox" value="UPIONQR" id="pmcheck_3" {...register('paymentMode')} />
                                    <label className="form-check-label" htmlFor="pmcheck_3">UPIONQR</label>
                                    </div>
                                </li>
                                <li className="list-group-item">
                                    <div className="form-check">
                                    <input className="form-check-input me-2 shadow-none" type="checkbox" value="UPIOFFQR" id="pmcheck_4" {...register('paymentMode')} />
                                    <label className="form-check-label" htmlFor="pmcheck_4">UPIOFFQR</label>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className='col-md-3 mb-2'>
                            <label className="form-label">Merchant Type <strong className='text-danger'>*</strong></label>
                            <ul className="list-group list-group-horizontal" ref={meTypeRef}>
                                <li className="list-group-item">
                                    <div className="form-check">
                                        <input className="form-check-input shadow-none" type="radio" value="MOTO" id="mtradio_1" {...register('merchantType')} />  
                                        <label className="form-check-label" htmlFor="mtradio_1">MOTO</label>
                                    </div>
                                </li>
                                <li className="list-group-item">
                                    <div className="form-check">
                                        <input className="form-check-input shadow-none" type="radio" value="SSL" id="mtradio_2" {...register('merchantType')} />  
                                        <label className="form-check-label" htmlFor="mtradio_2">SSL</label>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div> */}

                    <div className='col-12 m-2 d-flex justify-content-center'>
                        <button type='button' className="btn btn-danger mx-1" onClick={()=>setEditForm(false)}>CLOSE</button>
                        <button type='submit' className="btn _themebg-0 text-white mx-1">APPROVE</button>
                    </div>
                </form> 

                </div>
            </div>
        </div>
    </>)
}